
import { QuestionInfo } from "./question-info";

export class ThirdPartyDisclosure {
    constructor(
        public DateTimeAccepted: string,
        public IPAddress: string,
        public Questions: QuestionInfo[]
    ) {
    }
} 
